import networkCallWrapper from "hooks/networking/networkCallWrapper";
import { getPlatform } from "utils/platforms";

export type PlaidToken = {
    token: string
}

export async function getPlaidToken(): Promise<PlaidToken> {

    const url = "client_user/bank_account/add/token"
    const method = "GET"
    const service = "userCaas"

    const platform = getPlatform().toString()
    const deviceId = platform + "-user"

    const request = await networkCallWrapper(
        url,
        method,
        service,
        null,
        {},
        undefined,
        {
            'X-Platform': platform,
            'X-Device-Id': deviceId,
            'X-Source': 'sdk',
        }
    );

    return request as PlaidToken
}